// TOOK FROM https://github.com/nuxt-community/axios-module/issues/40
import Cookies from 'js-cookie'
import Cookie from 'cookie'
import config from '@/lib/config.js';
import moment from 'moment';
moment.locale('nl');
const opts = {}

let refreshInterval;

export default {
    namespaced: true,
    state: {
        data: null,
        token: null,
        refresh_token: null,
        authenticated: false
    },
    mutations: {
        SET_USER: function (state, user) {
            state.data = user;
        },
        SET_TOKEN: function (state, { token, refresh_token, expiresIn }) {
            state.token = token;
            state.refresh_token = refresh_token;
            state.expiresIn = expiresIn || null;


            if (!token || !refresh_token || !expiresIn) {
                Cookies.remove('token', opts);
                Cookies.remove('refresh_token', opts);
                Cookies.remove('expires_in');
                this._vm.$axios.defaults.headers.common['Authorization'] = '';
                state.authenticated = false;
                return;
            } else {
                state.authenticated = true;
            }

            // Store token in cookies
            this._vm.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

            Cookies.set('token', token, opts);
            Cookies.set('refresh_token', refresh_token, opts);
            Cookies.set('expires_in', expiresIn);
        },

    },

    getters: {
        isAuthenticated(state) {
            return state.authenticated;
        },
        companyId(state){
            if(state.data !== null && state.data.companies.length > 0){
                return state.data.companies[0].id;
            }
        },
        getNotifications(state){
            if(state.data && state.data.notifications.length > 0){
                return state.data.notifications;
            }
            else{
                return [];
            }
        },

        getInvoiceNumber(state) {
            if(state.data !== null) {
                return state.data.invoice_number;
            } else {
                return false;
            }
        },


        getInvoicePrefix(state) {
            if(state.data !== null) {
                return state.data.invoice_prefix;
            } else {
                return false;
            }
        },
        // USER ROLES
        isAdmin(state) {
            if(state.data !== null){
                return state.data.roles[0].name === 'admin';
            }
            return false;
        },
        isElevated(state){
            if(state.data !== null) {
                return state.data.roles[0].name === 'admin' || state.data.roles[0].name === 'franchise' || state.data.roles[0].name === 'subadmin';
            }  else {
                return false;
            }
        },
        isManager(state){
            console.log(state.data);
            if(state.data !== null){
                return state.data.roles[0].name === 'manager';
            }
            return false;
        },
        isFlexAgency(state){
            if(state.data !== null){
                return state.data.roles[0].name === 'flexagency';
            }
            return false;
        },
        isFlexEmployee(state){
            if(state.data !== null){
                return state.data.roles[0].name === 'flexemployee';
            }
            return false;
        },
        isHRManager(state){
            if(state.data !== null){
                return state.data.roles[0].name === 'hrmanager';
            }
            return false;
        },
        isPlanner(state){
            if(state.data !== null){
                return state.data.roles[0].name === 'planner';
            }
            return false;
        },
        isFreelancer(state){
            if(state.data !== null){
                return state.data.roles[0].name === 'freelancer';
            }
            return false;
        },
        isTemp(state){
            if(state.data !== null){
                return state.data.roles[0].name === 'temp';
            }
            return false;
        },
        isApproved(state){
            if(state.data !== null && state.data.approved){
                return true;
            }
            return false;
        },
        isSubAdmin(state){
            if(state.data !== null){
                return state.data.roles[0].name === 'subadmin';
            }
            return false;
        },
        isFranchise(state){
            if(state.data !== null){
                return state.data.roles[0].name === 'franchise';
            }
            return false;
        },
        role(state){
            if (state.data !== null && state.data.roles !== null) {
                return state.data.roles[0];
            }
            return false;
        },
        hasPayedSubscription(state) {
            if (state.data !== null) {
                let first_check =   state.data.subscription && 
                        typeof(state.data.subscription.id !== "undefined");

                if (first_check) {
                    // valid
                    if (state.data.subscription.ends_at === null) {
                        return true;
                    } 

                    let check = moment(state.data.subscription.ends_at);
                    let now   = moment();

                    return check.isAfter( now );
                }   
                
                return false;
            }
            
            return false;
        }
    },

    actions: {
        async authenticate({ commit, dispatch, getters, state }) {
            dispatch('load_token');
            dispatch('check_auth');
           
            try {
                await dispatch('set_user');
                
                return true;
            } catch (e) {
                return false;
            }
        },
        async load_token({ commit }) {
            // Try to extract token from cookies
            const cookieStr = document.cookie;
            const cookies = Cookie.parse(cookieStr || '') || {};
            const token = cookies.token;
            const refresh_token = cookies.refresh_token;
            const expiresIn = cookies.expires_in;
            let obj = { token, refresh_token, expiresIn };
            commit('SET_TOKEN', obj);
        },
        async check_auth({ commit, dispatch, getters, state }, req) {
            if (new Date() > new Date(parseInt(state.expiresIn))) {
                await _refreshToken(this, commit);
            }
            if (state.token !== null && state.refresh_token !== null) {
                state.authenticated = true;
                return;
            }

            state.authenticated = false;
            return false;
        },
        async register({commit, dispatch, getters, state}, formData) {
            try {
                await this._vm.$axios.post('users/register', formData);
                // AUTOMATIC LOGIN (DISABLED)
                // dispatch('login', {username: formData.email, password: formData.password});
            } catch (error) {
                throw error;
            }
        },
        async registercompany({commit, dispatch, getters, state}, formData) {
            try {
                await this._vm.$axios.post('companies/register', formData);
                // AUTOMATIC LOGIN (DISABLED)
                // dispatch('login', {username: formData.email, password: formData.password});
            } catch (error) {
                throw error;
            }
        },
        async registeremployee({commit, dispatch, getters, state}, formData) {
            try {
                await this._vm.$axios.post('users', formData);
                // AUTOMATIC LOGIN (DISABLED)
                // dispatch('login', {username: formData.email, password: formData.password});
            } catch (error) {
                throw error;
            }
        },
        async login({ commit, dispatch, state }, { username, password }) {
            try {
                if (this._vm.$loader) {
                    this._vm.$loader.show({ description: this._vm.$t('login') || 'Login' });
                }

                const { data } = await this._vm.$axios.post('oauth/token', {
                    username,
                    password,
                    grant_type: 'password',
                    client_id: config.apiClientID,
                    client_secret: config.apiClientSecret
                });

                let expiresIn = calculateExpiresIn(data.expires_in);
                
                commit('SET_TOKEN', { token: data.access_token, refresh_token: data.refresh_token, expiresIn: expiresIn });
                await dispatch('set_user');
                dispatch('track_vue_login');

                if (this._vm.$loader) {
                    this._vm.$loader.hide();
                }

            } catch (error) {
                throw error
            }
        },

        async logout({ commit }) {
            commit('SET_USER', null);
            commit('SET_TOKEN', { token: null, refresh_token: null, expiresIn: null });
            clearInterval(refreshInterval);
        },

        async set_user({ commit, dispatch, state }) {
            try {
                await dispatch('load_token');
                // No token
                if (!state.token) {
                    return Promise.reject(false);
                }
 
                if(refreshInterval === undefined){
                    dispatch('start_refresh_interval');
                }
                const { data } = await this._vm.$axios.get('users/self');
                commit('SET_USER', data.data);
                dispatch('data/getDefaultData', null, {root: true});
                
            } catch (error) {
                console.error("Set User didn't work: ", error);
                // Token doesn't work anymore, throw it out
                commit('SET_USER', null);
                commit('SET_TOKEN', { token: null, refreshToken: null, expiresIn: null });
                return Promise.reject();
            }
        },
        async track_vue_login() {
            try {
                const apiV2Url = config.apiUrl.replace(/\/v1\/?$/, '/v2/');
                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || null;

                await this._vm.$axios.post(`${apiV2Url}client-login-events`, {
                    app_version: config.appVersion,
                    timezone
                });
            } catch (error) {
                // Usage tracking must never prevent a successful login.
                console.warn('Could not register Vue login event');
            }
        },
        start_refresh_interval({ commit, getters, state }) {
            
            refreshInterval = setInterval(() => {

                // If authenticated, refresh token every 60 min
                // Get new token from header & replace token in storage and axios headers
                try {
                    if (!!state.data) {
                        _refreshToken(this, commit);
                    }
                } catch (error) {
                    clearInterval(refreshInterval);
                }
            }, 1000 * 60 * 60);
            // }, 6000);
        },
        manual_refresh({ getters, state }) {
            try {
                if (!!state.data) {
                    _refreshToken(this);
                }
            } catch (error) {
                clearInterval(refreshInterval);
            }
        },
        // GET USER BY ID
        async getUser({context}, id){
            try {
                let {data} = await this._vm.$axios.get(`users/${id}`);
                return Promise.resolve(data.data);
            } catch (e) {

                return Promise.reject(e);
            }
        },
    }
}

async function _refreshToken(store, commit) {
    try {
        const { data } = await store._vm.$axios.post('oauth/token', {
            refresh_token: store.state.user.refresh_token,
            grant_type: 'refresh_token',
            client_id: config.apiClientID,
            client_secret: config.apiClientSecret
        });
        let expiresIn = calculateExpiresIn(data.expires_in);
        commit('SET_TOKEN', { token: data.access_token, refresh_token: data.refresh_token, expiresIn: expiresIn });
    } catch (error) {
        console.error('error', error);
        return error;
    }
}

function calculateExpiresIn(expiresIn) {
    return new Date().getTime() + (expiresIn * 1000);
}



// WEBPACK FOOTER //
// ./src/store/modules/userStore.js